import { createIcon } from "@chakra-ui/icons";

const Code02 = createIcon({
  displayName: "Code02",
  viewBox: "0 0 24 24",
  path: [
    <path
      d="M17 17L22 12L17 7M7 7L2 12L7 17M14 3L10 21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    ></path>,
  ],
  defaultProps: { boxSize: 4 },
});

export default Code02;
